export default "/images/cafa246bc095fe51d85dce2660724c15.avif";